import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { CARD_IDS } from '@/components/AdvertisePayments/components/ExtraContent/ExtraContent.types';
import {
  PaymentSuccessCrownIcon,
  PaymentSuccessPrimaryTopIcon,
  PaymentSuccessSecondaryTopIcon
} from '@/components/ui/Icons/Icons';
import { useOverlayClickHandler } from '@/hooks/useOverlayClickHandler';
import { useThemeMode } from '@/hooks/useThemeMode';

import * as S from './Statuses.styles';

export type SuccessModalProps = {
  activeCard: string;
  onClose: () => void;
};

export const SuccessModal: FC<SuccessModalProps> = ({
  activeCard,
  onClose
}) => {
  const { t } = useTranslation();

  const isDark = useThemeMode('dark');

  const handleOverlayClick = useOverlayClickHandler(onClose);

  const isPremium = activeCard === CARD_IDS.PREMIUM;

  const title = isPremium
    ? t('Advertise.msg_premium_activated')
    : t('Advertise.msg_top_activated');

  const subtitle = isPremium
    ? t('Advertise.msg_premium_activated_desc')
    : t('Advertise.msg_top_activated_desc');

  const Icon = isPremium
    ? PaymentSuccessCrownIcon
    : isDark
      ? PaymentSuccessSecondaryTopIcon
      : PaymentSuccessPrimaryTopIcon;

  return (
    <S.StatusModalOverlay onClick={handleOverlayClick}>
      <S.StatusModalCard>
        <S.StatusIconWrapper $isStatus>{<Icon />}</S.StatusIconWrapper>
        <S.ContentWrapper>
          <S.StatusModalTitle>{title}</S.StatusModalTitle>
          <S.ModalExtraContentPaymentSubtitle>
            {subtitle}
          </S.ModalExtraContentPaymentSubtitle>
        </S.ContentWrapper>
        <S.ConfirmButton variant="primary" size="m" onClick={onClose}>
          {t('Advertise.success_button')}
        </S.ConfirmButton>
      </S.StatusModalCard>
    </S.StatusModalOverlay>
  );
};
